<script>
  import { getContext } from 'svelte';
  import { format } from 'svelte-i18n';

  import { Porthole } from '@client/components/porthole';

  import { getFlag } from '@client/utils/flags';

  const { context } = getContext('config');

  /**
   * @typedef {Object} ActivityEntry
   * @property {string} [sender] - The sender's email address.
   */

  /**
   * The activity entry containing sender metadata.
   * @type {ActivityEntry}
   */
  export let entry;

  /**
   * Whether to show sender information.
   * @type {boolean}
   */
  export let includeSender = false;
</script>

{#if context?.source === 'sfdc' || includeSender}
  <div class="sender">
    <Porthole
      details={{
        photoUrl: '',
        name: entry.sender,
        email: entry.sender
      }}
      size="xsmall"
    />
    <span>{entry.sender}</span>
  </div>
{/if}

<style lang="scss" src="./item-sender.scss"></style>
